module.exports = __webpack_public_path__ + "static/media/vumask.dd85f5a8.png";